import type { MessageBlock } from "@rakazo/contracts";
import { identitySource, preserveIdentitySource } from "./identity-source.js";

export const PEER_REPLY_PENDING_TEXT = "The reply hasn't arrived yet.";

export type MessageNoticeLabels = { peerReplyPending?: string };

/** Translate only an explicit server code, never infer meaning from prose.
 * Перекладаємо лише явний серверний код, а не вгадуємо зміст тексту. */
export function displayMessageNotice(
  block: MessageBlock,
  labels: MessageNoticeLabels,
): MessageBlock {
  const source = identitySource(block);
  if (
    source.kind !== "text" ||
    source.noticeCode !== "peer_reply_pending" ||
    !labels.peerReplyPending
  )
    return source;
  if (source.text === labels.peerReplyPending) return source;
  return preserveIdentitySource(block, { ...source, text: labels.peerReplyPending });
}
